import PropTypes from "prop-types";
import { LaneHeader, RightContent } from "../../styles/Base";
import Avatar from "../../../components/Avatar";
import styled from "styled-components";
import { colorCodes } from "../TaskDetail/ColorPicker";

export const Title = styled.div`
  cursor: ${(props) => (props.draggable ? "grab" : `pointer`)};
`;

const LaneHeaderWrapper = styled.div`
  padding: 5px;
`;

// Fallback color palette for lanes without bucket color
export const LANE_DOT_COLORS = [
  "#9ca3af", // 0 - Gray (no stage / default)
  "#3b82f6", // 1 - Blue
  "#f97316", // 2 - Orange
  "#22c55e", // 3 - Green
  "#ef4444", // 4 - Red
  "#a855f7", // 5 - Purple
  "#14b8a6", // 6 - Teal
  "#eab308", // 7 - Yellow
  "#ec4899", // 8 - Pink
  "#6366f1", // 9 - Indigo
];

/** Resolve bucket color string (e.g. "text-blue-500") to hex code via colorCodes */
export const resolveBucketColor = (color, index) => {
  if (color) {
    const match = colorCodes.find((cc) => cc.color === color);
    if (match) return match.code;
  }
  // Fallback to index-based color
  return LANE_DOT_COLORS[index % LANE_DOT_COLORS.length];
};

const LaneHeaderComponent = ({
  onDoubleClick = () => {},
  label,
  title,
  titleStyle,
  laneDraggable,
  imageUrl,
  extraHeaderLane,
  cards,
  index = 0,
  color,
}) => {
  const dotHex = resolveBucketColor(color, index);

  return (
    <LaneHeaderWrapper>
      <LaneHeader onDoubleClick={onDoubleClick}>
        <Title draggable={laneDraggable} style={titleStyle}>
          <div className={"w-full flex items-center gap-1.5"}>
            {imageUrl ? (
              <Avatar avatarUrl={imageUrl} />
            ) : (
              <span
                className="w-2.5 h-2.5 rounded-full shrink-0"
                style={{ backgroundColor: dotHex }}
              />
            )}
            <div
              title={title}
              className={"flex items-center gap-1.5 font-semibold text-sm min-w-0"}
            >
              <span className={"truncate"}>{title}</span>
              {cards.length > 0 && (
                <span className="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-gray-100 text-xs font-medium text-gray-600">
                  {cards.length}
                </span>
              )}
            </div>
          </div>
        </Title>
        {extraHeaderLane()}
        {label && (
          <RightContent>
            <div className={"w-full font-semibold"}>{label}</div>
          </RightContent>
        )}
      </LaneHeader>
    </LaneHeaderWrapper>
  );
};

LaneHeaderComponent.propTypes = {
  updateTitle: PropTypes.func,
  editLaneTitle: PropTypes.bool,
  canAddLanes: PropTypes.bool,
  laneDraggable: PropTypes.bool,
  label: PropTypes.string,
  title: PropTypes.string,
  color: PropTypes.string,
  onDelete: PropTypes.func,
  onDoubleClick: PropTypes.func,
  extraHeaderLane: PropTypes.func,
};

export default LaneHeaderComponent;
